import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";



function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const[upd1,setupd1]=useState("None");
const[upd2,setupd2]=useState("None");
const[upd3,setupd3]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[b17,setb17]=useState("None");
const[b18,setb18]=useState("None");
const[b19,setb19]=useState("None");
const[b20,setb20]=useState("None");

const[bb1,setbb1]=useState("None");
const[bb2,setbb2]=useState("None");
const[bb3,setbb3]=useState("None");
const[bb4,setbb4]=useState("None");
const[bb5,setbb5]=useState("None");
const[bb6,setbb6]=useState("None");
const[bb7,setbb7]=useState("None");
const[bb8,setbb8]=useState("None");
const[bb9,setbb9]=useState("None");
const[bb10,setbb10]=useState("None");
const[bb11,setbb11]=useState("None");
const[bb12,setbb12]=useState("None");
const[bb13,setbb13]=useState("None");
const[bb14,setbb14]=useState("None");
const[bb15,setbb15]=useState("None");
const[bb16,setbb16]=useState("None");
const[bb17,setbb17]=useState("None");
const[bb18,setbb18]=useState("None");
const[bb19,setbb19]=useState("None");
const[bb20,setbb20]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0xd202846d155061470a758f3c96764c0501ccbb31";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0x5edFa869dd568a7E99d0dA30817a484DC560ea4b";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
	  let alltasks1 = await contract.getMemos1(account[0]);
      setTasks1(alltasks1);

      var i = 0;
      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[0]);
      sea1(a1);
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const x4 = Number(alltasks[22])/1000000000000000000;
     setx4(x4);
      const b =Number(alltasks[2]);
     

     document.querySelector("#hid").value  = (alltasks[1]);
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);
document.querySelector("#wid").value  = Number(alltasks[15]);




     setB(b);

     

     const dd = Number(alltasks[9]);
          
     setDD(dd);

     const reward1 = Number(alltasks[58])/1000000000000000000;
          
     setreward1(reward1);
     
     const reward2 = Number(alltasks[11]);
    
     setreward2(reward2);

     if(reward2 == 1)
     {
      const reward2 = 10;
    
     setreward2(reward2);
     }

     if(reward2 == 2)
     {
      const reward2 = 35;
    
     setreward2(reward2);
     }

     if(reward2 == 3)
     {
      const reward2 = 135;
    
     setreward2(reward2);
     }

     if(reward2 == 4)
     {
      const reward2 = 635;
    
     setreward2(reward2);
     }
     const reward3 = Number(alltasks[28])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	
								
	
      const reward4 =  Number(alltasks[23])/1000000000000000000;
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);




      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);

      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);


     const x1 = Number(alltasks[17])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[18])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[19])/1000000000000000000;
     setx3(x3);
     


     const dd2 = Number(alltasks[12]);
          
     setDD2(dd2);

     const dd1 =  Date.now() / 1000;
     setDD1(dd1);


     const tt1 = Math.trunc((dd1 - dd) / (3660 * 24 )) ;
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);

     const tt2 = Math.trunc((dd1 - dd2) / (3600 * 24  )) ;
     //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
       
       settt2(tt2);
      
       document.querySelector("#tt2").value = tt2;
       
       const b1 = Number(alltasks[5]) ;
       setb1(b1);
       const b2 = Number(alltasks[6]) ;
       setb2(b2);
       const b3 = Number(alltasks[7]) ;
       setb3(b3);
       const b4 = Number(alltasks[8]) ;
       setb4(b4);
       const b5 = Number(alltasks[9]) ;
       setb5(b5);
       const b6 = Number(alltasks[10]) ;
       setb6(b6);
       const b7 = Number(alltasks[22]) ;
       setb7(b7);
       const b8 = Number(alltasks[24]) ;
       setb8(b8);
         const b9 = Number(alltasks[25]) ;
       setb9(b9);
       const b10 = Number(alltasks[26]) ;
       setb10(b10);
       const b11 = Number(alltasks[27]) ;
       setb11(b11);
       const b12 = Number(alltasks[28]) ;
       setb12(b12);
       const b13 = Number(alltasks[29]) ;
       setb13(b13);
       const b14 = Number(alltasks[30]) ;
       setb14(b14);
       const b15 = Number(alltasks[31]) ;
       setb15(b15);
       const b16 = Number(alltasks[32]) ;
       setb16(b16);
       const b17 = Number(alltasks[33]) ;
       setb17(b17);
       const b18 = Number(alltasks[34]) ;
       setb18(b18);
       const b19 = Number(alltasks[35]) ;
       setb19(b19);
       const b20 = Number(alltasks[36]) ;
       setb20(b20);


        const bb1 = Number(alltasks[2]) ;
       setbb1(bb1);
       const bb2 = Number(alltasks[37]) ;
       setbb2(bb2);
       const bb3 = Number(alltasks[38]) ;
       setbb3(bb3);
       const bb4 = Number(alltasks[39]) ;
       setbb4(bb4);
       const bb5 = Number(alltasks[40]) ;
       setbb5(bb5);
       const bb6 = Number(alltasks[41]) ;
       setbb6(bb6);
       const bb7 = Number(alltasks[42]) ;
       setbb7(bb7);
       const bb8 = Number(alltasks[43]) ;
       setbb8(bb8);
         const bb9 = Number(alltasks[44]) ;
       setbb9(bb9);
       const bb10 = Number(alltasks[45]) ;
       setbb10(bb10);
       const bb11 = Number(alltasks[46]) ;
       setbb11(bb11);
       const bb12 = Number(alltasks[47]) ;
       setbb12(bb12);
       const bb13 = Number(alltasks[48]) ;
       setbb13(bb13);
       const bb14 = Number(alltasks[49]) ;
       setbb14(bb14);
       const bb15 = Number(alltasks[50]) ;
       setbb15(bb15);
       const bb16 = Number(alltasks[51]) ;
       setbb16(bb16);
       const bb17 = Number(alltasks[52]) ;
       setbb17(bb17);
       const bb18 = Number(alltasks[53]) ;
       setbb18(bb18);
       const bb19 = Number(alltasks[54]) ;
       setbb19(bb19);
       const bb20 = Number(alltasks[55]) ;
       setbb20(bb20);
     
	   const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const level1 = Number(alltasks[21]) ;
          
 setLevel1(level1);
 const a3 = Number(alltasks1[2])/1000000000000000000;
          
     sea3(a3);

    // document.querySelector("#wi1").value = roi2;
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
    // const a3 = Number(alltasks1[2])/1000000000000000000;
          
   //  sea3(a3);
     const a2 = Number(alltasks[24]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const pack1 = Number(alltasks[22])/1000000000000000000;
setpackage1(pack1);
     const tt =  Number(alltasks[16])/1000000000000000000;
     settt(tt);
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://billionvisionz.com/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd1 = Number(alltasks[29])/1000000000000000000;
          
     setupd1(upd1);
	 const upd2 = Number(alltasks[30])/1000000000000000000;
          
     setupd2(upd2);
	 const upd3 = Number(alltasks[31])/1000000000000000000;
          
     setupd3(upd3);


console.log(pack);




 
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
	<input type="hidden" id ="wid"></input>
   

					
						
					<div class="row">
					<div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box box-mb">
					  <figure class="service-reboticon">
						<img
						  src="./assets/images/service-reboticon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					  <h4>Join Referral Program</h4>
					  <p class="text-size-16 mb-2">
					  <input type="text" id ="amt" ></input> <br></br><br></br>
					  <Buy state={state}  />
					  <br></br>
					  Enter the USDT amount with which you want to start or upgrade with. 
					  </p>
					  
					</div>
				  </div>

				  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="box-top">
					  <div class="service-box box-mb">
						<figure class="service-learningicon">
						  <img
							src="./assets/images/service-learningicon.png"
							alt=""
							class="img-fluid"
						  />
						</figure>
						<h4>Withdraw Funds </h4>
						<p class="text-size-16 mb-2">
						<input type="text" id ="test" ></input><br></br><br></br>
						 <Buy3 state={state}  />
						 <br></br>
					  Enter the USDT amount  which you want to Withdraw. 
					
						</p>
					   
					  </div>
					</div>
				  </div>
          </div>
            
		<div class="row">
				  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box">
					  <figure class="service-scienceicon">
						<img
						  src="./assets/images/service-scienceicon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					  <h4> Trade</h4>
					  <p class="text-size-16 mb-2">
					  <Buy1 state={state}  />
						 <br></br>
					  Visit here daily to trade your funds to get higher returns 
					
					 </p>
					</div>
				  </div>

				  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="box-top">
					  <div class="service-box">
						<figure class="service-analysicon">
						  <img
							src="./assets/images/service-analysicon.png"
							alt=""
							class="img-fluid"
						  />
						</figure>
						<h4>Total Income</h4>
						<p class="text-size-16 mb-2">
						
						{tt} <br></br>USDT <br></br>
						
						Total Value of your all incomes added together
						</p>
					   
					  </div>
					</div>
				  </div>

          <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="box-top">
					  <div class="service-box">
						<figure class="service-analysicon">
						  <img
							src="./assets/images/service-analysicon.png"
							alt=""
							class="img-fluid"
						  />
						</figure>
						<h4>Pending Income</h4>
						<p class="text-size-16 mb-2">
						
						{tt-wlevel1} <br></br>USDT <br></br>
						
						Total Value of your Pending incomes added together
						</p>
					   
					  </div>
					</div>
				  </div>
				 
				</div>


	
				<div class="row">
					<div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box box-mb">
					  <figure class="service-reboticon">
						<img
						  src="./assets/images/service-reboticon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					  <h4> My Investment</h4>
					  <p class="text-size-16 mb-2">
					 	{pack}<br></br>
						USDT
						<br></br>
						the total amount which is invested by you or upgraded
						 </p>
					  
					</div>
				  </div>


				 
				  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="box-top">
					  <div class="service-box">
						<figure class="service-analysicon">
						  <img
							src="./assets/images/service-analysicon.png"
							alt=""
							class="img-fluid"
						  />
						</figure>
						<h4>Direct Team</h4>
						<p class="text-size-16 mb-2">
						
						{direct}
						<br></br>
						direct team size which are reffered by you
						</p>
					   
					  </div>
					</div>
				  </div>

				 
				</div>


	     	
				<div class="row">
					<div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box box-mb">
					  <figure class="service-reboticon">
						<img
						  src="./assets/images/service-reboticon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					  <h4>Level Team</h4>
					  <p class="text-size-16 mb-2">
					 
  
{level}
<br></br>
total team which are refered by your team
 </p>
					  
					</div>
				  </div>
         		<div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box box-mb">
					  <figure class="service-reboticon">
						<img
						  src="./assets/images/service-reboticon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>

    <h4>Team Business</h4>
    <p class="text-size-16 mb-2">
      {level1}
      <br />
      total business done by your team
    </p>

  </div>
</div>

				
          </div>
          
           
	

				<div class="row">
					<div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box box-mb">
					  <figure class="service-reboticon">
						<img
						  src="./assets/images/service-reboticon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					  <h4> Direct Business</h4>
						<p class="text-size-16 mb-2"> {x2}<br></br>
						USDT
           
<br></br>
direct business by your direct team
					  </p>
					  
					</div>
				  </div>


				  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="box-top">
					  <div class="service-box">
						<figure class="service-analysicon">
						  <img
							src="./assets/images/service-analysicon.png"
							alt=""
							class="img-fluid"
						  />
						</figure>
						<p> <h4> Level Bonus</h4>
						
						{x3}<br></br>
						USDT
<br></br>
level bonus achieved on trading bonus of your team
						</p>
					   
					  </div>
					</div>
				  </div>

			
          </div>

		  <div class="row">
					<div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box box-mb">
					  <figure class="service-reboticon">
						<img
						  src="./assets/images/service-reboticon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					  <p> <h4> Trading Bonus</h4>
						 {x1}<br></br>
						USDT <br></br>
trading bonus is achieved by participate in daily trades
					  </p>
					  
					</div>
				  </div>

				  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box">
					  <figure class="service-scienceicon">
						<img
						  src="./assets/images/service-scienceicon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					
					  <p><h4> Saturday Club Bonus </h4>
						{reward1} <br></br>
						USDT
						<br></br> Saturday Club Bonus is weekly Royalty on given target
						</p>
					</div>
				  </div>
			
  </div>
			
            
		<div class="row">
				  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box">
					  <figure class="service-scienceicon">
						<img
						  src="./assets/images/service-scienceicon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					
					  <p><h4> Reward Bonus </h4>
						{reward2} <br></br>
						USDT
						Rewards achieved by you on achieving given targets
						</p>
					</div>
				  </div>
					<div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box box-mb">
					  <figure class="service-reboticon">
						<img
						  src="./assets/images/service-reboticon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					  <p> <h4>TOTAL WITHDRAWL</h4>
						 {wlevel1} <br></br>
						USDT<br></br>
funds which you had successfully Withdrawn
					  </p>
					  
					
					</div>
				  </div>
  
				</div>

		

			
		

<div class="row">
			<div className="col-lg-6 col-md-6 col-sm-6 col-12">
  <div
    className="service-box box-mb h-100 d-flex flex-column justify-content-between text-center"
    style={{
      minHeight: "260px",
      overflow: "hidden",
      boxSizing: "border-box",
    }}
  >
    

    <h4>My Referlink</h4>

   
    <div style={{ maxHeight: "40px", overflow: "hidden" }}>
      <p
        style={{
          fontSize: "0.6rem",
          lineHeight: "1rem",
          wordBreak: "break-all",
          overflowWrap: "anywhere",
          whiteSpace: "normal",
          padding: "0 6px",
          margin: 0,
        }}
      >
        {referlink}
      </p>
    </div>

    <button
      className="btn btn-sm mt-1"
      onClick={() => navigator.clipboard.writeText(referlink)}
    >
      <img src="copy.png" width="15" alt="copy" /> Copy
    </button>

  </div>
</div>


				   <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="box-top">
					  <div class="service-box">
						<figure class="service-analysicon">
						  <img
							src="./assets/images/service-analysicon.png"
							alt=""
							class="img-fluid"
						  />
						</figure>
						<h4>My Refer</h4>
						<p class="text-size-16 mb-2">
						
							{refer}
						</p>
					   
					  </div>
					</div>
				  </div>
				  
				
				</div>
					<div class="row">
				 

				    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
					<div class="service-box">
					  <figure class="service-scienceicon">
						<img
						  src="./assets/images/service-scienceicon.png"
						  alt=""
						  class="img-fluid"
						/>
					  </figure>
					
					  <h4>  My Account</h4>
							<p class="text-size-16 mb-2">

                 {account}
              </p>
		
					</div>
				  </div>
				   <div className="col-lg-6 col-md-6 col-sm-6 col-12">
  <div className="box-top">
    <div
      className="service-box box-mb h-100 text-center"
      style={{
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
     

      <h4>My Account</h4>

     
      <p
        className="text-size-16 mb-2"
        style={{
          fontSize: "0.7rem",
          lineHeight: "1rem",
          wordBreak: "break-all",
          overflowWrap: "anywhere",
          whiteSpace: "normal",
          maxWidth: "100%",
          padding: "0 8px",
          marginBottom: 0,
        }}
      >
       
      </p>
    </div>
  </div>
</div>

				  
				
				</div>
                  
				 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 1 Business </h4>
      <p>
       {b1} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 1 Team</h4>
      <p class="text-size-16 mb-2">
         {bb1} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 2 Business </h4>
      <p>
       {b2}  
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 2 Team</h4>
      <p class="text-size-16 mb-2">
         {bb2} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 3 Business </h4>
      <p>
       {b3} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 3 Team</h4>
      <p class="text-size-16 mb-2">
         {bb3} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 4 Business </h4>
      <p>
       {b4} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 4 Team</h4>
      <p class="text-size-16 mb-2">
         {bb4} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 5 Business </h4>
      <p>
       {b5} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 5 Team</h4>
      <p class="text-size-16 mb-2">
         {bb5} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 6 Business </h4>
      <p>
       {b6} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 6 Team</h4>
      <p class="text-size-16 mb-2">
         {bb6} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 7 Business </h4>
      <p>
       {b7} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 7 Team</h4>
      <p class="text-size-16 mb-2">
         {bb7} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 8 Business </h4>
      <p>
       {b8} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 8 Team</h4>
      <p class="text-size-16 mb-2">
         {bb8} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 9 Business </h4>
      <p>
       {b9} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 9 Team</h4>
      <p class="text-size-16 mb-2">
         {bb9} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 10 Business </h4>
      <p>
       {b11} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 11 Team</h4>
      <p class="text-size-16 mb-2">
         {bb11} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 12 Business </h4>
      <p>
       {b12} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 12 Team</h4>
      <p class="text-size-16 mb-2">
         {bb12} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 13 Business </h4>
      <p>
       {b13} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 13 Team</h4>
      <p class="text-size-16 mb-2">
         {bb13} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 14 Business </h4>
      <p>
       {b14} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 14 Team</h4>
      <p class="text-size-16 mb-2">
         {bb14} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 15 Business </h4>
      <p>
       {b15} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 15 Team</h4>
      <p class="text-size-16 mb-2">
         {bb15} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 16 Business </h4>
      <p>
       {b16} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 16 Team</h4>
      <p class="text-size-16 mb-2">
         {bb16} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 17 Business </h4>
      <p>
       {b17} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 17 Team</h4>
      <p class="text-size-16 mb-2">
         {bb17} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 18 Business </h4>
      <p>
       {b18} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 18 Team</h4>
      <p class="text-size-16 mb-2">
         {bb18} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 19 Business </h4>
      <p>
       {b19} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 19 Team</h4>
      <p class="text-size-16 mb-2">
         {bb19} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 20 Business </h4>
      <p>
       {b20} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 20 Team</h4>
      <p class="text-size-16 mb-2">
         {bb20} 
      </p>
    </div>
  </div>
</div>

	 <div class="row">
  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-reboticon">
        <img src="./assets/images/service-reboticon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 1 Business </h4>
      <p>
       {b1} 
	   USDT
						
      </p>
    </div>
  </div>

  <div class="col-6 col-md-6 col-lg-6">
    <div class="service-box box-mb">
      <figure class="service-learningicon">
        <img src="./assets/images/service-learningicon.png" alt="" class="img-fluid" />
      </figure>

      <h4>Level 1 Team</h4>
      <p class="text-size-16 mb-2">
         {bb1} 
      </p>
    </div>
  </div>
</div>




            
	

				
          
          



				




  


   </div>

  );
}

export default App;